import type { IconComponent } from '@alltrails/denali/components/Icon';
import Beach from '@alltrails/denali/icons/Beach';
import CalenderStar from '@alltrails/denali/icons/CalenderStar';
import Cave from '@alltrails/denali/icons/Cave';
import City from '@alltrails/denali/icons/City';
import HistoricSite from '@alltrails/denali/icons/HistoricSite';
import HotSpring from '@alltrails/denali/icons/HotSpring';
import Lake from '@alltrails/denali/icons/Lake';
import PlacePark from '@alltrails/denali/icons/PlacePark';
import Pub from '@alltrails/denali/icons/Pub';
import RailTrail from '@alltrails/denali/icons/RailTrail';
import River from '@alltrails/denali/icons/River';
import Views from '@alltrails/denali/icons/Views';
import Waterfall from '@alltrails/denali/icons/Waterfall';
import Wildflowers from '@alltrails/denali/icons/Wildflowers';
import Wildlife from '@alltrails/denali/icons/Wildlife';
import type TrailFeature from '@alltrails/types/TrailFeature';

const icons: Partial<Record<TrailFeature, IconComponent>> = {
  beach: Beach,
  cave: Cave,
  'city-walk': City,
  event: CalenderStar,
  forest: PlacePark,
  'historic-site': HistoricSite,
  'hot-springs': HotSpring,
  lake: Lake,
  'pub-crawl': Pub,
  'rails-trails': RailTrail,
  river: River,
  views: Views,
  waterfall: Waterfall,
  'wild-flowers': Wildflowers,
  wildlife: Wildlife
};

const getFeatureIcon = (feature: TrailFeature): IconComponent | undefined => icons[feature];

export default getFeatureIcon;
